/* eslint-disable no-param-reassign */

/* eslint-disable max-len */
import produce from "immer";

import {
  EDIT_STATUS_SHIPPER,
  GET_LIST_SHIPPER,
  GET_LIST_SHIPPER_FAILURE,
  GET_LIST_SHIPPER_SUCCESS,
  GET_ONE_SHIPPER,
  GET_ONE_SHIPPER_FAILURE,
  GET_ONE_SHIPPER_SUCCESS
} from "src/actions/shipperAction";

const initialState = {
  listShipper: [],
  shipper: {},
  updateStatus: "",
  totalShipper: 0,
  loading: false
};

const shipperReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_SHIPPER: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_LIST_SHIPPER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.listShipper = response.data;
        draft.totalShipper = response.total;
        draft.loading = false;
      });
    }

    case GET_LIST_SHIPPER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_ONE_SHIPPER: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_ONE_SHIPPER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.shipper = response;
        draft.loading = false;
      });
    }

    case GET_ONE_SHIPPER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case EDIT_STATUS_SHIPPER: {
      const {id, data} = action.payload;
      return produce(state, (draft) => {
        draft.listShipper = state.listShipper.map((ship) => {
          if (ship.id === id) {
            return {...ship, is_active: data};
          }
          return ship;
        });
      });
    }

    default: {
      return state;
    }
  }
};

export default shipperReducer;
